/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { ConversationItemResponse, GetConversationApiArg } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getConversation: build.query<ConversationItemResponse, GetConversationApiArg>({
      query: (queryArg) => ({
        method: 'GET',
        url: `/v1/conversations/${queryArg.conversationId}`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as getConversationApi };
export const { useGetConversationQuery, useLazyGetConversationQuery } = injectedRtkApi;
